export default __webpack_public_path__ + "static/media/cyberport-removebg-preview.d01b7cdb.png";